module.exports = __webpack_public_path__ + "static/img/31.3420db50.jpeg";